<template>
  <Wrapper :type="type" @delete="$emit('delete')">
    <div slot="preview">
      <iframe :src="data.src" :height="200" width="100%"></iframe>
    </div>
    <v-layout slot="edition" wrap row>
      <v-flex xs12>
        <v-text-field
          :value="data.src"
          label="Source"
          outline
          @input="setValue"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </Wrapper>
</template>

<script>
import Wrapper from "../../components/widgets/Wrapper";

export default {
  name: "WidgetWebview",
  components: {
    Wrapper
  },
  model: {
    prop: "data"
  },
  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loadingError: false
    };
  },
  methods: {
    setValue(src) {
      this.loadingError = false;
      this.$emit("input", {
        src
      });
    }
  }
};
</script>
